import mixpanel from 'mixpanel-browser';
import { PROJECT_NAME, REACT_APP_MIXPANEL_TOKEN } from 'config.js';

mixpanel.init(REACT_APP_MIXPANEL_TOKEN);

const env_check = process.env.NODE_ENV === 'production';
const actions = {
  identify: id => {
    if (env_check) {
      mixpanel.identify(id);
      mixpanel.register({
        project: PROJECT_NAME,
      });
    }
  },
  alias: id => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  register: props => {
    if (env_check) mixpanel.register(props);
  },
  people: {
    set: props => {
      if (env_check) mixpanel.people.set(props);
    },
  },
  reset: () => {
    if (env_check) mixpanel.reset();
  },
};

export const Mixpanel = actions;
